import React from "react";
import { Container } from "react-bootstrap";
import "./Third.css";
import nativeApp from "../../../../Asset/native-app.svg";
import cross from "../../../../Asset/cross-platform.svg";
import rightArrow from "../../../../Asset/arrow-right.svg";
import { useNavigate } from "react-router-dom";

const Third = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="third-mobileapp-section">
        <Container>
          <div className="top-text-after-third-services">
            <h2>
              WE PORTRAY <span>YOUR VISION</span>
            </h2>
          </div>
          <p>
            At Codeffi, we start by listening closely to understand your unique
            business needs. Then our strategic approach pushes your brand to new
            heights of success. Leveraging the power of mobile, we help you gain
            a competitive edge, increase profits, boost customer engagement,
            optimize workflow, and make your competitors envious.
          </p>
          <p>
            Our mobile app expertise combined with a deep focus on user
            experience allows us to create seamless solutions tailored for your
            business. We help drive growth by engaging customers in new and
            innovative ways. And we ensure your operations run efficiently
            behind the scenes.
          </p>
          <p>
            With robust technology and strategic vision, we can elevate your
            brand and help you succeed on all fronts. So let us listen to where
            you want to go, and together we’ll get you there - and make your
            competition wish they were you.
          </p>
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div
                className="potray-card-item d-flex"
                onClick={() => {
                  navigate("/ContactUs");
                }}
              >
                <div className="card-img">
                  <img alt="cardImage" src={nativeApp} />
                </div>
                <div className="card-content">
                  <h5>Native App Development </h5>
                  <div className="sort-info">
                    Bringing your business and seamless user experiences to life
                    through native app development.
                  </div>
                  <p>
                    <span>Talk to Our Experts </span>
                    <img alt="card" className="svg" src={rightArrow} />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div
                className="potray-card-item d-flex"
                onClick={() => {
                  navigate("/ContactUs");
                }}
              >
                <div className="card-img">
                  <img alt="card" src={cross} />
                </div>
                <div className="card-content">
                  <h5>Cross-Platform App Development </h5>
                  <div className="sort-info">
                    Unify your brand across platforms with our cross-app
                    development expertise.
                  </div>
                  <p>
                    <span>Talk to Our Experts </span>
                    <img alt="card" className="svg" src={rightArrow} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
